/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
const e=2216,o=4096;function r(r){return e+o*r.symbolLayers.length+r.complexity.memory.resourceBytes}export{r as getSymbolMemorySize};
